import { connect } from 'react-redux';
import { getIsMobile, searchTypeSelector } from 'src/store/view/selectors';
import SubtitleContainer from './SubtitleContainer';
import { hotelsCountSelector } from '../../store/hotels/selectors';
import { isAwaitingFiltration } from '../../searchStatus/selectors';

const mapStateToProps = (state) => ({
  searchType: searchTypeSelector(state),
  hotelsCount: hotelsCountSelector(state),
  awaitFiltration: isAwaitingFiltration(state),
  isMobile: getIsMobile(state),
});

export default connect(mapStateToProps)(SubtitleContainer);
